var _rect, _rect2, _mask, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyCripto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 1,
    fill: "#F4F4F4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 9.5,
    width: 14,
    height: 17,
    rx: 0.5,
    fill: "white",
    stroke: "#333333"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_1_226",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 7C7 6.44771 7.44772 6 8 6H21.6279C22.1802 6 22.6279 6.44772 22.6279 7V23.5581C22.6279 24.1104 22.1802 24.5581 21.6279 24.5581H8C7.44772 24.5581 7 24.1104 7 23.5581V7Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 7C6 5.89543 6.89543 5 8 5H20.6279C21.7325 5 22.6279 5.89543 22.6279 7C22.6279 7 22.1802 7 21.6279 7H8H6ZM22.6279 24.5581H7H22.6279ZM8 24.5581C6.89543 24.5581 6 23.6627 6 22.5581V7C6 5.89543 6.89543 5 8 5V7V23.5581C8 24.1104 8 24.5581 8 24.5581ZM22.6279 6V24.5581V6Z",
    fill: "#333333",
    mask: "url(#path-3-inside-1_1_226)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyCripto);
export default __webpack_public_path__ + "static/media/copyCripto.0cec096a37b575c0a78e2e41bb63f686.svg";
export { ForwardRef as ReactComponent };